import { connect } from 'react-redux';

import { IA_KEY } from 'helpers/ia-logic';
import { selectActiveVenue, selectMsInventoryVenues, selectIaLogic } from 'selectors/general';

import {
  selectInstructors,
  selectSelectedInstructorId,
  selectInstructorsIsLoading,
  selectShouldScrollToItem,
} from './Instructors.selectors';
import { setSelectedInstructor } from './Instructors.saga';
import Instructors from './Instructors';

const mapStateToProps = state => {
  const { venueId } = selectActiveVenue(state);
  const { featureIsSupported } = selectIaLogic(state, IA_KEY.MANAGE_INSTRUCTORS, venueId);

  return {
    instructors: selectInstructors(state, venueId),
    venues: selectMsInventoryVenues(state),
    activeVenueId: venueId,
    isLoading: selectInstructorsIsLoading(state, venueId),
    selectedInstructorId: selectSelectedInstructorId(state),
    shouldScrollToItem: selectShouldScrollToItem(state),
    featureIsSupported,
  };
};

const mapDispatchToProps = {
  handleInstructorChange: setSelectedInstructor,
};

export default connect(mapStateToProps, mapDispatchToProps)(Instructors);
